export default {
	name: "Italiano",

	'global.itemCounts': `{total, plural,
		=0 {nessun contenuto}
		other {}
	}{collections, plural,
		=0 {}
		one {una collezione}
		other {{collections} collezioni}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {una storia}
		other {{stories} storie}
	}`,

	'cover.stories': `{itemCount, plural,
		one {storia}
		other {storie}
	}`,

	'searchbutton.placeholder': 'cerca...',

	'flow.empty': 'Non ci sono contenuti da visualizzare.',

	'forms.submitted': 'Informazioni inviate correttamente.',
	'forms.errored': 'Si è verificato un errore durante l\'invio delle informazioni.',
	'forms.required': 'Campo obbligatorio',
	'forms.close': 'Grazie',

	'prevnext.prev': 'storia precedente',
	'prevnext.next': 'prossima storia',

	'navigation.back': 'Indietro',

	'share.back': 'Indietro',
	'share.embed': 'Incorpora',
	'share.share': 'Condividi',
	'share.cover': 'Copertina',
	'share.custom': 'Elemento personalizzato',
	'share.inline': 'Incorpora elemento',
	'share.customhere': 'INSERISCI QUI IL TUO ELEMENTO',
	'share.scriptonce': 'Lo script di cui sopra puó essere inserito solo una volta per pagina',
	'share.FacebookLabel': 'Condividi su Facebook',
	'share.TwitterLabel': 'Tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'Condividi',

	'more.showCollection': 'Mostra tutte le storie',
	'more.showMore': 'Mostra storie più vecchie',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Mostra più contenuti',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Mostra tutte le storie',

	'passwordScreen.passwordPlaceholder': 'password',
	'passwordScreen.usernamePlaceholder': 'nome utente',
	'passwordScreen.subTitle': 'è una {type, select, story {storia} collection {collezione}} protetta',
	'passwordScreen.submit': 'Invia',
	'passwordScreen.error': 'Autorizzazione negata',
	'like.label': 'Mi piace {likeCount, number}',
	'like.noLikeLabel': 'Mi piace',
};


// WEBPACK FOOTER //
// ./lib/locales/it.js